import { Button, Col, Form, Input, Modal, Row, Select, Radio, InputNumber } from "antd";
import userApi from "api/user";
import { CALI_IGD, XL_IGD, ingredientOptions } from "constants/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalCUIngredient({
  form,
  selected,
  openModal,
  onCloseModal,
  onSubmit,
}) {
  const { t } = useTranslation()

  const type = Form.useWatch('type', form);
  const isVegetarian = Form.useWatch('isVegetarian', form);

  useEffect(() => {
    if (selected) {
      form.setFieldsValue({
        type: selected.type,
        isVegetarian: selected.isVegetarian ? 1 : 0,
        name: selected.name,
        core: selected.core,
        shell: selected.shell,
        numSalmon: selected.numSalmon,
        numTuna: selected.numTuna,
      });
    }
  }, [selected, form]);

  return (
    <Modal
      title={t('ingredientSushi')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCloseModal}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="type"
          label={t('type')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select options={ingredientOptions.map(item => ({
            ...item,
            label: t(item.label),
          }))} />
        </Form.Item>
        <Form.Item
          name="isVegetarian"
          label={t('vegetarian')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Radio.Group disabled={selected}>
            <Radio value={0}>{t("no")}</Radio>
            <Radio value={1}>{t("yes")}</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="name"
          label={t('name')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="core"
          label={t('core')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        {
          (type === CALI_IGD || type === XL_IGD) &&
          <Form.Item
            name="shell"
            label={t('shell')}
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
        }
        {
          !isVegetarian &&
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="numSalmon"
                label={t('quantitySalmon')}
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="numTuna"
                label={t('quantityTuna')}
                required
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        }
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button style={{ width: "100%" }} onClick={onCloseModal}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
